<template lang="html">
  <BaseLoading  :spinning="coachesLoading">
    <div class="events-list-wrap coach-table-wrap create-profile-wrapper">
      <div class="container">
        <div class="events-content-wrap">
          <div class="head">
            <div class="head-title">
              <h2 class="form-title">Coaching Staff</h2>
            </div>
            <BaseButton
              type="primary"
              v-if="canAdd"
              class="add-event-btn"
              icon="plus"
              @click="newCoach"
              >Add New Coach</BaseButton
            >
          </div>
          <BaseTable
            class="margin-t-1"
            :columns="columns"
            :data="coaches"
            :loading="coachesLoading"
            :pagination="{}"
            :show-zero="coachesMeta.total === 0"
          />
          <BaseModal
            class="coach-modal-wrapper"
            title="Change Coach Role"
            :visible="postActionModal"
            ok-text="Yes"
            cancel-text="No"
            :closable="false"
            @ok="handleModalSubmit"
            @cancel="changeRoleAction"
          >
            <div slot="content">
              <p>Select A Role</p>
              <BaseSelect
                :items="postActionModalItems"
                labelPath="label"
                valuePath="value"
                :value="selectedRole"
                @change="value => handleRoleSelection('selectedRole', value)"
              />
            </div>
          </BaseModal>
          <BaseModal
            :visible="showReactivateDrawer"
            :title="`Reactivate ${coachToReactivate.coachname}?`"
            ok-text="Reactivate"
            ok-type="primary"
            @cancel="toggleModal('showReactivateDrawer')"
            @ok="reactivateCoach"
          >
            <p slot="content">
              <span class="bold">{{ coachToReactivate.coachname }}</span>
              will be reactivated and will be able to perform their usual
              actions.
            </p>
          </BaseModal>
        </div>
      </div>
    </div>
  </BaseLoading>
</template>

<script>
const COACH_STORE_KEY = "coachStore";
import { COACH_INDEX_TABLE } from "@/utils/columns";
import { mapGetters } from "vuex";
import { Base, College } from "@/models";
import { Tooltip } from "ant-design-vue";

const POST_ACTION_SELECT_WRAPPER = [
  {
    label: "College Normal Coach",
    value: "collegeNormalCoach"
  },
  {
    label: "College PROFILE MAINTAINER",
    value: "collegeProfileMaintainer"
  }
];
export default {
  data() {
    return {
      paginationLimit: 10,
      searchQuery: {},
      currentPage: 1,
      selectedRole: "",
      selectedIdForRoleChange: "",
      postActionModal: false,
      postActionModalItems: POST_ACTION_SELECT_WRAPPER,
      coachToReactivate: {},
      showReactivateDrawer: false
    };
  },
  computed: {
    paginationOptions() {
      return {
        total: this.coachesMeta.total || 10,
        current: this.currentPage || 1,
        simple: true
      };
    },
    currentRole() {
      return JSON.parse(localStorage["user-permissions"]);
    },
    canAdd() {
      return this.exceptCollegeNormalCoach();
    },
    columns() {
      return [
        ...COACH_INDEX_TABLE,
        {
          title: "Status",
          dataIndex: "status",
          // width: 130,
          customRender: (_text, rowData, _index) => {
            return <p class={rowData.badgeClass}>{rowData.status}</p>;
          }
        },
        {
          title: "Deactivated By",
          dataIndex: "deactivatedBy",
          customRender: (_text, rowData, _index) => {
            return rowData.deactivatedBy && !rowData.isActive ? (
              <div
                class="poptip-reason-wrapper"
                style={rowData.deactivatedBy ? "" : "display: none"}
              >
                <p>{rowData.deactivatedBy}</p>
                <Tooltip class="cursor-pointer" placement="bottomRight">
                  <span slot="title">{rowData.dReason}</span>
                  View Reason
                </Tooltip>
              </div>
            ) : (
              ""
            );
          }
        },
        {
          title: "Actions",
          dataIndex: "actions",
          width: 200,
          customRender: (_text, rowData, _index) => {
            const isDeactivatedByAdmin =
              !rowData.isActive && rowData.deactivatedBy === "admin";
            const isDeactivated = !rowData.isActive;
            const loggedInPermission =
              College.coachPermissions[
                JSON.parse(localStorage["user-permissions"])
              ];
            return (
              <div class="table-actions-wrapper">
                <a
                  on-click={event =>
                    this.handleActionButtons(event, "view", rowData)
                  }
                  style={"color: #282d7f"}
                >
                  View
                </a>
                {rowData.id === this.profileId && !isDeactivatedByAdmin ? (
                  <a
                    on-click={event =>
                      this.handleActionButtons(
                        event,
                        isDeactivated ? "reactivate" : "edit",
                        rowData
                      )
                    }
                  >
                    {!rowData.isActive ? "Reactivate" : "Edit"}
                  </a>
                ) : (
                  ""
                )}
                {isDeactivatedByAdmin ||
                College.coachPermissions[rowData.role] > loggedInPermission ||
                rowData.id === this.profileId ? (
                  ""
                ) :
                  loggedInPermission !== 1 ?
                 (
                  <a
                    on-click={event =>
                      this.handleActionButtons(
                        event,
                        !rowData.isActive ? "reactivate" : "edit",
                        rowData
                      )
                    }
                  >
                    {!rowData.isActive ? "Reactivate" : "Edit"}
                  </a>
                ) : ''}
                {rowData.isActive &&
                College.coachPermissions[rowData.role] <= loggedInPermission &&
                rowData.id !== this.profileId ? 
                loggedInPermission !== 1 ? (
                  <a
                    on-click={event =>
                      this.handleActionButtons(event, "changeRole", rowData)
                    }
                  >
                    Change Role
                  </a>
                )
                  :''
                : (
                  ""
                )}
              </div>
            );
          }
        }
      ];
    },
    ...mapGetters({
      coaches: `${COACH_STORE_KEY}/coaches`,
      coachesLoading: `${COACH_STORE_KEY}/coachesLoading`,
      coachesMeta: `${COACH_STORE_KEY}/coachesMeta`
    }),
    profileId() {
      return Base.profileId();
    }
  },
  mounted() {
    this.dispatcher();
  },
  methods: {
    newCoach() {
      this.$router.push(
        `/${this.profileId}/college_profile/coaching_staffs/new`
      );
    },
    async handleTableChange(pagination) {
      await this.dispatcher(pagination.current);
    },
    handleRoleSelection(key, value) {
      this[key] = value;
    },
    changeRoleAction(rowData) {
      this.postActionModal = !this.postActionModal;
      this.selectedIdForRoleChange = rowData.coachId;
      this.selectedKeyForRoleChange = rowData.key;
      this["selectedRole"] = rowData.role;
    },
    async handleModalSubmit() {
      await this.$store.dispatch(`${COACH_STORE_KEY}/updateRole`, {
        id: this.selectedIdForRoleChange,
        role: this.selectedRole
      });
      this.postActionModal = !this.postActionModal;
      await this.$store.dispatch(`${COACH_STORE_KEY}/changeCoachPosition`, {
        id: this.selectedKeyForRoleChange,
        role: this.selectedRole
      });
    },
    handleActionButtons(event, action, rowData) {
      this[`${action}Action`](rowData);
    },
    viewAction(rowData) {
      this.$router.push(
        `/${this.profileId}/college_profile/coaching_staffs/${rowData.coachId}/details`
      );
    },
    editAction(rowData) {
      this.$router.push(
        `/${this.profileId}/college_profile/coaching_staffs/${rowData.coachId}/edit`
      );
    },
    reactivateAction(rowData) {
      this.showReactivateDrawer = true;
      this.coachToReactivate = rowData;
    },
    async reactivateCoach() {
      await this.$store.dispatch(`${COACH_STORE_KEY}/toggleActivation`, {
        slug: "collegecoach",
        coachId: this.coachToReactivate.coachId,
        isActive: !this.coachToReactivate.isActive,
        flag: this.coachToReactivate.isActive ? "deActivate" : "reActivate",
        dReason: this.reason,
        CollegeId: this.coachToReactivate.CollegeId.Id,
        isDeactivated: this.coachToReactivate.isActive
      });
      await this.$store.dispatch(`${COACH_STORE_KEY}/changeCoachActivation`, {
        id: this.coachToReactivate.key,
        isActive: !this.coachToReactivate.isActive
      });
      this.dispatcher();
      this.showReactivateDrawer = false;
    },
    async dispatcher(page = 1) {
      this.currentPage = page;
      await this.$store.dispatch(`${COACH_STORE_KEY}/getCoaches`, {
        sort: "createdAt",
        CollegeId: localStorage["college-id"],
        ...this.searchQuery
      });
    },
    toggleModal(modalType) {
      this[modalType] = !this[modalType];
    }
  }
};
</script>

<style lang="sass">
.add-event-btn
  background: #2a328a
  border-color: #2a328a
  text-transform: uppercase
  margin-bottom: 1rem
.coach-modal-wrapper
  .ant-form-item-control
    .ant-form-item-children
      div
        width: 80%
.poptip-reason-wrapper
  &:last-child
    font-style: italic
.active-badge
  text-align: center
  border: 1px solid green
  background-color: rgba(0, 255, 0, .1)
  border-radius: 5px
  color: green
  text-transform: uppercase
  margin: 0rem !important
.in-badge
  text-align: center
  border: 1px solid blue
  background-color: rgba(0, 0, 255, .1)
  border-radius: 5px
  color: blue
  text-transform: uppercase
  margin: 0rem !important
.inactive-badge
  text-align: center
  border: 1px solid red
  background-color: rgba(255, 0, 0, .1)
  border-radius: 5px
  color: red
  margin: 0rem !important
  text-transform: uppercase
.table-actions-wrapper
  a
    margin-right: 10px
</style>
